<div class="row">
  <div class="col-8">

  </div>
<div style="width: 40%" class="box-parent col-4">
   <div class="dropdown-label-group">
      <p-dropdown [options]="dashboards"
                  [(ngModel)]="selectDashboard"
                  class="dv-dropdown"
                  selectId="year"
                  id="dashboards"
                  placeholder="{{'DOC-DASHBOARD.DASHBOARDLIST' | translate}}"
                  (onChange)="choosedashboard()"

      >
      </p-dropdown>
   <label for="dashboards">{{'DOC-DASHBOARD.DASHBOARDLIST' | translate}}</label>

   </div>

     </div>
</div>


 <div [ngSwitch]="keepdashboard" >
   <div *ngSwitchCase="null" class="mt-2">
     <app-dashboard-document></app-dashboard-document>
        </div>
        <div *ngSwitchCase="2" >
          <div style="margin-top: -30px">
            <app-email-dashboard></app-email-dashboard>

          </div>
        </div>
</div>




<!--<div class="header">-->
<!--  <div class="row">-->
<!--    <div class="col-md">-->
<!--      <h3>{{'DASHBOARD.TITLE' | translate}}</h3>-->
<!--    </div>-->
<!--    &lt;!&ndash;<div class="col-6 col-md-2">&ndash;&gt;-->
<!--      &lt;!&ndash;<div class="dropdown-label-group">&ndash;&gt;-->
<!--        &lt;!&ndash;<p-dropdown&ndash;&gt;-->
<!--          &lt;!&ndash;class="dv-dropdown"&ndash;&gt;-->
<!--          &lt;!&ndash;selectId="company"&ndash;&gt;-->
<!--          &lt;!&ndash;[options]="company"&ndash;&gt;-->
<!--          &lt;!&ndash;[(ngModel)]="selectedCompany"&ndash;&gt;-->
<!--          &lt;!&ndash;[autoDisplayFirst]="false"&ndash;&gt;-->
<!--          &lt;!&ndash;placeholder="บริษัท"&ndash;&gt;-->
<!--        &lt;!&ndash;&gt;&ndash;&gt;-->
<!--        &lt;!&ndash;</p-dropdown>&ndash;&gt;-->
<!--        &lt;!&ndash;<label for="company">บริษัท</label>&ndash;&gt;-->
<!--      &lt;!&ndash;</div>&ndash;&gt;-->
<!--    &lt;!&ndash;</div>&ndash;&gt;-->
<!--    &lt;!&ndash;<div class="col-6 col-md-2">&ndash;&gt;-->
<!--      &lt;!&ndash;<div class="dropdown-label-group">&ndash;&gt;-->
<!--        &lt;!&ndash;<p-dropdown&ndash;&gt;-->
<!--          &lt;!&ndash;class="dv-dropdown"&ndash;&gt;-->
<!--          &lt;!&ndash;selectId="companyBusiness"&ndash;&gt;-->
<!--          &lt;!&ndash;[options]="homeproGroup"&ndash;&gt;-->
<!--          &lt;!&ndash;[(ngModel)]="selectedHomeproGroup"&ndash;&gt;-->
<!--          &lt;!&ndash;[autoDisplayFirst]="false"&ndash;&gt;-->
<!--          &lt;!&ndash;placeholder="ประเภทธุรกิจ"&ndash;&gt;-->
<!--        &lt;!&ndash;&gt;&ndash;&gt;-->
<!--        &lt;!&ndash;</p-dropdown>&ndash;&gt;-->
<!--        &lt;!&ndash;<label for="companyBusiness">ประเภทธุรกิจ</label>&ndash;&gt;-->
<!--      &lt;!&ndash;</div>&ndash;&gt;-->
<!--    &lt;!&ndash;</div>&ndash;&gt;-->
<!--    <div>-->
<!--      &lt;!&ndash;<div class="dropdown-label-group">&ndash;&gt;-->
<!--        <p-dropdown-->
<!--          class="dv-dropdown"-->
<!--          selectId="year"-->
<!--          [options]="yearList"-->
<!--          [(ngModel)]="selectedYear"-->
<!--          [autoDisplayFirst]="false"-->
<!--          placeholder="ปี"-->
<!--          (onChange)="loadMonthlyData()"-->
<!--        >-->
<!--        </p-dropdown>-->
<!--        &lt;!&ndash;<label for="year">ปี</label>&ndash;&gt;-->
<!--      &lt;!&ndash;</div>&ndash;&gt;-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--<div class="box-parent scrollable" style="height: calc(100vh - 2.25rem - 150px);">-->
<!--  <canvas id="signing-counter-bar-chart">{{ charts_signing_counter_bar_stacked }}</canvas>-->
<!--</div>-->



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-list/dashboard-list.component.html